'use client'

import Link from 'next/link'

const LINKS = {
  Product: [
    { label: 'Features',    href: '/features' },
    { label: 'Pricing',     href: '/pricing' },
    { label: 'For Coaches', href: '/for-coaches' },
    { label: 'For Parents', href: '/for-parents' },
  ],
  Company: [
    { label: 'About',   href: '/about' },
    { label: 'Contact', href: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy',    href: '/privacy' },
    { label: 'Terms of Service',  href: '/terms' },
  ],
}

const LINK_STYLE: React.CSSProperties = {
  fontSize: 14,
  color: '#94a3b8',
  textDecoration: 'none',
  transition: 'color 150ms ease',
  display: 'block',
  lineHeight: 1,
}

export function MarketingFooter() {
  return (
    <footer
      style={{
        backgroundColor: '#13201B',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        padding: '60px 0 32px',
      }}
    >
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px' }}>

        {/* Top row: brand + link columns */}
        <div
          className="grid sm:grid-cols-2 lg:grid-cols-4"
          style={{ gap: 48, marginBottom: 48 }}
        >
          {/* Brand */}
          <div>
            {/* Sprint 61.58 — wordmark fixed. Was default sans + #F5E642
                (Tailwind yellow-400, off-brand). Now matches MarketingNav +
                LandingNav + HomepageFooter: Caveat font + #F5E642 period.
                One brand mark across every Chalk surface. */}
            <Link href="/" style={{ display: 'flex', alignItems: 'baseline', textDecoration: 'none', marginBottom: 12 }}>
              <span style={{ fontFamily: 'var(--font-caveat)', fontSize: 26, fontWeight: 700, color: '#ffffff', lineHeight: 1 }}>chalk</span>
              <span style={{ fontFamily: 'var(--font-caveat)', fontSize: 26, fontWeight: 700, color: '#F5E642', lineHeight: 1 }}>.</span>
            </Link>
            <p style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.65, maxWidth: 220 }}>
              Built for youth sports coaches and clubs.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(LINKS).map(([group, links]) => (
            <div key={group}>
              <p
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#94a3b8',
                  textTransform: 'uppercase',
                  letterSpacing: '0.12em',
                  marginBottom: 16,
                }}
              >
                {group}
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
                {links.map(({ label, href }) => (
                  <li key={label}>
                    <Link
                      href={href}
                      style={LINK_STYLE}
                      onMouseEnter={(e) => { e.currentTarget.style.color = '#ffffff' }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = '#94a3b8' }}
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom row */}
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.06)',
            paddingTop: 24,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          <p style={{ fontSize: 13, color: '#94a3b8' }}>
            © 2026 Chalk Sports, LLC. All rights reserved.
          </p>
          <a
            href="https://instagram.com/chalksports"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: 13,
              color: '#94a3b8',
              textDecoration: 'none',
              transition: 'color 150ms ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = '#ffffff' }}
            onMouseLeave={(e) => { e.currentTarget.style.color = '#94a3b8' }}
          >
            Instagram @chalksports
          </a>
        </div>
      </div>
    </footer>
  )
}
